
import settings from '../../../server/settings'
import XHeader from 'vux/src/components/x-header/index.vue'

import api from '~api'
export default {
name: "feeProjectDetail",
components: {
XHeader
},
data() {
return {
feeYear: new Date().getFullYear(),
detail: {}
}
},
mounted() {
this.detail = this.$route.params.detail || {};
},
methods: {
backList() {
this.$router.push({name: 'feeProject'})
},
gotopay() {
var _this = this;
var obj = {
"channelPayWay": "JSAPI",
"amount": parseFloat(_this.detail.feeAmount) * 100 + "",
"terminalCode": "TM20190614112332",
"device": "WEB",
"extra": "{\"subOpenId\":\"" + window.localStorage.getItem("openId") + "\"}",
"subject": _this.feeYear + _this.detail.projectName,
"body": _this.feeYear + "其他费用-" + _this.detail.projectName,
"stuCode": window.localStorage.getItem("stuCode"),
"collection": "西京学院",
"majorId": window.localStorage.getItem("majorId"),
"orderType": "4",
"projectId": _this.detail.projectId,
"year": _this.feeYear + ""
};
_this.$vux.loading.show({
text: 'Loading'
})
_this.$http.post(settings.api_root + "/payment/pay", obj).then(res => {
_this.$vux.loading.hide();
if (res.data != null) {
var params = {
"timeStamp": res.data.results.payParams.timeStamp,
"package": res.data.results.payParams.package,
"appId": settings.appid,
"signType": res.data.results.payParams.signType,
"nonceStr": res.data.results.payParams.nonceStr
};
var sign = _this.sortParam(params) + "key=wyyzxml88888mtdbq66666GoodSystem";
sign = _this.$md5(sign).toUpperCase();
WeixinJSBridge.invoke(
'getBrandWCPayRequest', {
"appId": settings.appid,
"timeStamp": res.data.results.payParams.timeStamp,
"nonceStr": res.data.results.payParams.nonceStr,
"package": res.data.results.payParams.package,
"signType": res.data.results.payParams.signType,
"paySign": sign
},
function(res) {
if (res.err_msg == "get_brand_wcpay_request:ok") {
_this.$msgbox('温馨提示：', "缴费成功！");
_this.$vux.loading.hide();
_this.$router.push({name: 'home'});
}
if (res.err_msg == "get_brand_wcpay_request:cancel") {
_this.$msgbox('温馨提示：', "取消支付，缴费失败！");
_this.$vux.loading.hide();
}
if (res.err_msg == "get_brand_wcpay_request:fail") {
_this.$msgbox('温馨提示：', "缴费失败，请刷新后重试！");
_this.$vux.loading.hide();
}
});
}
})
},
sortParam(obj) {
var paramArr = [];
for (var o in obj) {
paramArr.push(o + "=" + obj[o] + "&");
}
paramArr.sort();
var str = paramArr.join(":::").replace(/:::/g, "");
return str
},
formatTime(time) {
if (!time) return '';
if (typeof time === 'number') {
var d = new Date(time);
var y = d.getFullYear();
var m = (d.getMonth() + 1 < 10 ? '0' : '') + (d.getMonth() + 1);
var day = (d.getDate() < 10 ? '0' : '') + d.getDate();
var h = (d.getHours() < 10 ? '0' : '') + d.getHours();
var min = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
var s = (d.getSeconds() < 10 ? '0' : '') + d.getSeconds();
return y + '-' + m + '-' + day + ' ' + h + ':' + min + ':' + s;
}
return String(time).substring(0, 19);
}
}
}



// WEBPACK FOOTER //
// ./src/components/fee-project/FeeProjectDetail.vue